var map = {
	"./test.jade": 4
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.id = 2;
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;



/*****************
 ** WEBPACK FOOTER
 ** ./resolving/context/~/subcontent ./resolving/context/loaders/queryloader.js?query!^\.\/.*\.jade$
 ** module id = 2
 ** module chunks = 0
 **/